module.exports = __webpack_public_path__ + "static/media/Tokio_Marine_logo.82f5b7cf.png";